module.exports = __webpack_public_path__ + "img/TrophyTwo.3e953299.svg";